import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from 'showdown';
import { makeStyles } from '@material-ui/core/styles';
import ReactMde from 'react-mde';
import type { CSSProperties } from '@material-ui/styles';

const converter = new Showdown.Converter({
	simplifiedAutoLink: true,
	strikethrough: true,
	tables: true,
	tasklists: true,
});

const useStyles = makeStyles(() => ({
	markdown: {
		'& .mde-header': {
			display: 'none',
		},
		'& .mde-preview': {
			minHeight: '31px !important',
		},
		'& .react-mde': {
			border: 'none',
		},
		minHeight: '40px !important',
		width: '100%',
	},
}));

interface Props {
	value?: string;
	style?: CSSProperties;
}

export function MarkdownText({ style, value }: Props) {
	const classes = useStyles();

	return (
		<div className={classes.markdown} style={style}>
			<ReactMde
				generateMarkdownPreview={async (markdown) =>
					await Promise.resolve(converter.makeHtml(markdown))
				}
				selectedTab={'preview'}
				value={value}
			/>
		</div>
	);
}
